'use strict';

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _require = require('./helpers'),
    compare = _require.compare,
    intersection = _require.intersection,
    semver = _require.semver;

var modulesByVersions = require('./modules-by-versions');

var modules = require('./modules');

module.exports = function (raw) {
  var corejs = semver(raw);

  if (corejs.major !== 3) {
    throw RangeError('This version of `core-js-compat` works only with `core-js@3`.');
  }

  var result = [];

  for (var _i = 0, _Object$keys = Object.keys(modulesByVersions); _i < _Object$keys.length; _i++) {
    var version = _Object$keys[_i];

    if (compare(version, '<=', corejs)) {
      result.push.apply(result, _toConsumableArray(modulesByVersions[version]));
    }
  }

  return intersection(result, modules);
};